import { takeLatest, put, call } from "redux-saga/effects";
import axios from "axios";
import { UnautherizedResponse } from "../GetUser/GetUserActions";
import ACTIONS from "./CronSettingsActionTypes";
import {
  deleteCronSettingsResponse,
  getCronReminderEmailsListResponse,
  getCronSettingsListResponse,
  postCronSettingsResponse,
  putCronSettingsResponse,
  putStatusCronSettingsResponse,
} from "./CronSettingsActions";
import { axiosPost, axiosPut, axiosDelete, axiosGet } from "../../Utils/axios";

export function* onGetCronSettingsHelperSaga({ payload }) {
  try {
    let response = yield call(() =>
      axiosPost("cron_settings/index", payload).then((res) => res?.data)
    );

    yield put(getCronSettingsListResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostCronSettingsHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost("cron_settings/new", payload).then((res) => res?.data)
    );
    yield put(postCronSettingsResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutCronSettingsHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`cron_settings/${payload.id}`, payload).then((res) => res?.data)
    );
    yield put(putCronSettingsResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutStatusCronSettingsHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`cron_settings/status/${payload.id}`, payload).then(
        (res) => res?.data
      )
    );
    yield put(putStatusCronSettingsResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onDeleteCronSettingsHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosDelete(`cron_settings/${payload.id}`, payload).then(
        (res) => res?.data
      )
    );
    yield put(deleteCronSettingsResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetCronReminderEmailsHelperSaga() {
  try {
    const response = yield call(() =>
      axiosGet(`cron_settings/reminder_emails/`).then((res) => res?.data)
    );
    yield put(getCronReminderEmailsListResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* CronSettingWatcherSaga() {
  yield takeLatest(
    ACTIONS.GET_CRON_REMINDER_EMAILS_LIST_REQUEST,
    onGetCronReminderEmailsHelperSaga
  );
  yield takeLatest(
    ACTIONS.GET_CRON_SETTINGS_LIST_REQUEST,
    onGetCronSettingsHelperSaga
  );
  yield takeLatest(
    ACTIONS.POST_CRON_SETTINGS_REQUEST,
    onPostCronSettingsHelperSaga
  );
  yield takeLatest(
    ACTIONS.PUT_CRON_SETTINGS_REQUEST,
    onPutCronSettingsHelperSaga
  );
  yield takeLatest(
    ACTIONS.DELETE_CRON_SETTINGS_REQUEST,
    onDeleteCronSettingsHelperSaga
  );

  yield takeLatest(
    ACTIONS.PUT_STATUS_CRON_SETTINGS_REQUEST,
    onPutStatusCronSettingsHelperSaga
  );
}
